<script setup lang="ts">
defineProps<{
  class?: string
}>()
</script>

<template>
  <img
    :class="$props.class || 'w-10 h-10'"
    src="/logo-icon.svg"
    alt=""
    aria-hidden="true"
    data-brand-mark="openmuse"
    width="512"
    height="512"
  />
</template>
